/**
 * Creates a stable-enough local identifier without assuming randomUUID support.
 * Older Android WebViews used by some WeChat versions do not expose it.
 */
export function createId(): string {
  if (
    typeof globalThis.crypto !== "undefined" &&
    typeof globalThis.crypto.randomUUID === "function"
  ) {
    return globalThis.crypto.randomUUID();
  }

  return `deskflow-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
}
